'use client';

import { useMemo } from 'react';
import {
  getGamesCurrenciesKey,
  parseGamesCurrenciesKey,
} from '@/helpers/gamesCurrencies';
import { useGetCommonStore } from '@/store/commonStore';

export const useGamesCurrencies = () => {
  const useCommonStore = useGetCommonStore();
  const currenciesKey = useCommonStore(getGamesCurrenciesKey);

  return useMemo(() => parseGamesCurrenciesKey(currenciesKey), [currenciesKey]);
};
